module.exports = "<div class=\"col-resumen\">\n  <h1>hola</h1>\n</div>\n"